import SubscribeEbook from './SubscribeEbook'

export default SubscribeEbook
